/**
 * @packageDocumentation
 * @module HackerAPI.Event.Sponsor.Prize
 */
import { __extends } from "tslib";
import Base from "../../../base/base";
import { parseDate } from "../../../utils/utils";
import HackerAPIFetch from "../../../hackerapi-fetch/hackerapi-fetch";
/**
 * A data container for things related to a sponsor's prize for an event
 * @class
 * @extends { HackerAPI.Base }
 */
var Prize = /** @class */ (function (_super) {
    __extends(Prize, _super);
    /**
     * Creates a new Prize instance
     * @constructor
     * @param prize
     */
    function Prize(_a) {
        var _b = _a === void 0 ? {} : _a, id = _b.id, name = _b.name, prize = _b.prize, description = _b.description, quantity = _b.quantity, sponsor_id = _b.sponsor_id, sponsorId = _b.sponsorId, created_at = _b.created_at, createdAt = _b.createdAt, updated_at = _b.updated_at, updatedAt = _b.updatedAt;
        var _this = _super.call(this) || this;
        /**
         * The prize ID
         * @type { number }
         */
        _this.id = id;
        /**
         * The name of the prize
         * @type { string }
         */
        _this.name = name;
        /**
         * No idea what the difference between this and name is
         * @type { string }
         */
        _this.prize = prize;
        /**
         * The description of the prize
         * @type { string }
         */
        _this.description = description;
        /**
         * Some number related to the prize
         * @type { number }
         */
        _this.quantity = quantity;
        /**
         * The ID of the sponsor who's giving away the prize
         * @type { number }
         */
        _this.sponsorId = sponsor_id || sponsorId;
        /**
         * When the prize was created
         * @type { Date }
         */
        _this.createdAt = parseDate(created_at || createdAt);
        /**
         * When the prize was last updated
         * @type { Date }
         */
        _this.updatedAt = parseDate(updated_at || updatedAt);
        return _this;
    }
    /**
     * Gets a sponsor prize for an event
     * @param event
     * @param event.slug
     * @param sponsor
     * @param sponsor.id
     * @param prize
     * @param prize.id
     * @param token
     * @returns
     */
    Prize.fetch = function (_a, _b, _c, token) {
        var slug = _a.slug;
        var sponsorId = _b.id;
        var prizeId = _c.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/sponsors/" + sponsorId + "/prizes/" + prizeId,
            method: "GET",
            token: token
        }).then(function (data) { return new Prize(data); });
    };
    /**
     * Adds a sponsor prize for an event
     * @param event
     * @param event.slug
     * @param sponsor
     * @param sponsor.id
     * @param prize
     * @param prize.id
     * @param token
     * @returns
     */
    Prize.create = function (_a, _b, prize, token) {
        var slug = _a.slug;
        var id = _b.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/sponsors/" + id + "/prizes",
            method: "POST",
            body: prize.toHackerAPIFormat(),
            token: token
        }).then(function (data) { return new Prize(data); });
    };
    /**
     * Updates a sponsor prize for an event
     * @param event
     * @param event.slug
     * @param sponsor
     * @param sponsor.id
     * @param prize
     * @param prize.id
     * @param token
     * @returns
     */
    Prize.updateSponsorPrize = function (_a, _b, prize, token) {
        var slug = _a.slug;
        var id = _b.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/sponsors/" + id + "/prizes/" + prize.id,
            method: "PUT",
            body: prize.toHackerAPIFormat(),
            token: token
        }).then(function (data) { return new Prize(data); });
    };
    /**
     * Deletes a sponsor prize for an event
     * @param event
     * @param event.slug
     * @param sponsor
     * @param sponsor.id
     * @param prize
     * @param prize.id
     * @param token
     * @returns
     */
    Prize.deleteSponsorPrize = function (_a, _b, _c, token) {
        var slug = _a.slug;
        var sponsorId = _b.id;
        var prizeId = _c.id;
        return HackerAPIFetch({
            path: "/v2/events/" + slug + "/sponsors/" + sponsorId + "/prizes/" + prizeId,
            method: "DELETE",
            token: token
        });
    };
    return Prize;
}(Base));
export default Prize;
//# sourceMappingURL=prize.js.map